<template>
  <div style="display: flex; flex-direction: column">
    <div class="checkout-address-selection-body">
      <div
        v-for="address in addresses"
        :key="address.id"
        :class="getAddressRowStyle(address)"
        @click="handleClick(address.id)"
      >
        <input
          :id="'address_' + address.id"
          v-model="selectedId"
          type="radio"
          name="checkout_address"
          :value="address.id"
        />
        <address-block :address="address"></address-block>
      </div>
      <div style="padding: 1rem; text-align: left">
        <button
          class="btn btn-sm btn-secondary"
          style="margin-left: 3rem; margin-top: 1rem"
          @click="handleSecondaryClick"
        >
          <i class="fa fa-plus"></i> Add new address
        </button>
      </div>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row-reverse;
        flex-wrap: wrap-reverse;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem;
        background-color: #eeeeee;
      "
    >
      <button class="btn btn-primary" @click="handleSubmit">Update</button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../../../store/stores";
import AddressBlock from "../elements/AddressBlock.vue";

export default {
  store,
  components: { AddressBlock },
  props: {
    selectedAddressId: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      selectedId: null,
    };
  },
  computed: {
    ...mapGetters({
      addresses: "checkout/addresses",
    }),
  },
  mounted() {
    this.selectedId = this.selectedAddressId;
  },
  methods: {
    getAddressRowStyle(address) {
      let val = "checkout-address-row";

      if (address.id === this.selectedId) {
        val += " checkout-address-row-selected";
      }

      return val;
    },

    handleClick(id) {
      this.selectedId = id;
    },

    handleSubmit() {
      this.$emit("handleUpdate", this.selectedId);
      this.$parent.$emit("handleClose");
    },

    handleSecondaryClick() {
      this.$emit("toggleAddAddress");
    },
  },
};
</script>

<style scoped>
.checkout-address-selection-body {
  padding: 3rem 2rem 2rem;
  cursor: pointer;
}

.checkout-address-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2rem 1.5rem;
  border: 1px solid #ffffff;
  border-radius: 1rem;
  transition: background-color 0.2s, border 0.2s;
}

.checkout-address-row-selected {
  background-color: #f5e1cc;
  border: 1px solid #d16c00;
}

.checkout-address-row input {
  margin-right: 2rem;
}

@media (min-width: 768px) {
  .checkout-address-selection-body {
    padding: 3rem 3rem 2rem;
  }
}
</style>
